<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Phone Number Details</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickOk"
                >
                    Ok
                </v-btn>

            </v-toolbar-items>
        </v-toolbar>

        <v-card-text
            style="margin-top: 15px;"
        >
            <div
                v-for="(result, index) in results"
                :key="index"
                style="margin-bottom: 15px;"
            >
                <h1
                    style="margin-bottom: 15px;"
                >
                    {{result.endpoint_label}}
                </h1>
                <m-phone-number-validation-data
                    :value="result"
                />
            </div>

            <m-select-employee-endpoint-dialog
                v-if="conversation_id != null"
                ref="select-endpoint-dialog"
                :selected_endpoint="active_endpoint"
                v-on:select-endpoint="onStartConversationFromAnotherEndpoint"
            />

            <v-btn
                v-if="conversation_id != null"
                v-on:click="onClickStartConversationFromAnotherEndpoint"
            >
                Start conversation from another number...
            </v-btn>

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>
const E164 = require('@/js/E164.js');
export default {

    data() {
        return {
            dialog: false,
            is_valid: true,
            results: [],
            conversation_id: null,
            active_endpoint: null,
        }
    },

    methods: {

        showDialog(results)
        {
            this.active_endpoint = null;
            this.conversation_id = null;

            if ( this.$route.params.endpoint != null && this.$route.params.conversation_id != null )
            {
                this.active_endpoint = E164.fullEndpoint(this.$route.params.endpoint);
                this.conversation_id = this.$route.params.conversation_id != 'none' ? this.$route.params.conversation_id : null;
            }
        
            this.results = results;
            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }
        
            // The dialog is showing...
            if ( this.is_valid )
            {
                // data is valid, so save 
                this.save();
                this.dialog = false;
                next(false);
                return;
            }
        
            this.$rc.snackbar('You must either correct the errors or discard your changes.',1500);
            this.dialog = true;
            next(false);
        },

        onClickSave()
        {
            this.save();
            this.closeDialog();
        },

        onClickOk()
        {
            this.closeDialog();
        },

        save()
        {
            // Nothing is changed by this dialog, so nothing to save...
        },

        onClickStartConversationFromAnotherEndpoint()
        {
            this.$refs['select-endpoint-dialog'].showDialog();
        },

        onStartConversationFromAnotherEndpoint(new_endpoint)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/conversations/create-conversation-from-another-ooe',
            
                'params' : {
                        'new_ooe': new_endpoint,
                        'old_ooe': this.active_endpoint,
                        'old_conversation_id': this.conversation_id,
                    },
            
                'on_success': (data) => {
                        this.closeDialog();

                        this.$router.push({
                            'name': 'home-routed',
                            'params' : {
                                'endpoint': data.new_ooe_short,
                                'conversation_id': data.new_conversation_id,
                            }
                        });
                    },
            
                'on_error': 'Unable to start conversation from another phone number',
            });

        },
    },
}
</script>

<style lang="scss" scoped>
</style>